var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoDeborde(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-703.000000, -853.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(329.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.000000, 471.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.000000, 238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M15.5927277,-1.77635684e-15 C18.1116522,-1.77635684e-15 20.4929566,0.600332133 22.601083,1.66543881 C22.3878996,2.04556792 22.1802409,2.42938246 21.9838596,2.80983968 C20.0599232,1.84363768 17.888635,1.29939397 15.5927277,1.29939397 C7.71190322,1.29939397 1.29939397,7.71190322 1.29939397,15.5927277 C1.29939397,23.4735521 7.71190322,29.8860614 15.5927277,29.8860614 C23.4735521,29.8860614 29.8860614,23.4735521 29.8860614,15.5927277 C29.8860614,13.824796 29.563349,12.130758 28.9737426,10.566432 C29.3367693,10.2207601 29.6480488,9.82116202 29.8955768,9.38059903 C30.7247614,11.2851171 31.1854553,13.3861176 31.1854553,15.5927277 C31.1854553,24.1908176 24.1908176,31.1854553 15.5927277,31.1854553 C6.99463775,31.1854553 -1.77635684e-15,24.1908176 -1.77635684e-15,15.5927277 C-1.77635684e-15,6.99463775 6.99463775,-1.77635684e-15 15.5927277,-1.77635684e-15 Z",
    id: "Combined-Shape",
    stroke: "#000000",
    strokeWidth: 0.8,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M28.5427394,6.41968662 C28.5427394,4.95562609 26.217402,1.43734109 25.5427394,0.447681572 C24.8680767,1.43961095 22.5427394,4.95562609 22.5427394,6.41968662 C22.5427394,8.09030452 23.8898158,9.44768157 25.5427394,9.44768157 C27.1956629,9.44768157 28.5427394,8.08803466 28.5427394,6.41968662 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M10.5,17 C9.12125,17 8,15.43025 8,13.5 C8,11.56975 9.12125,10 10.5,10 C11.87875,10 13,11.56975 13,13.5 C13,15.43025 11.87875,17 10.5,17 Z",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M20.5,17 C19.12125,17 18,15.43025 18,13.5 C18,11.56975 19.12125,10 20.5,10 C21.87875,10 23,11.56975 23,13.5 C23,15.43025 21.87875,17 20.5,17 Z",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M9.38889367,23.0601095 L10.3788353,21.866781 C10.7314528,21.441717 11.3618881,21.3829876 11.7869521,21.735605 C11.8425753,21.781748 11.8930325,21.8337849 11.9374393,21.8908038 L12.4781362,22.5850647 C12.8174863,23.020794 13.4458122,23.0989248 13.8815415,22.7595747 C13.9146684,22.7337752 13.9461375,22.7059148 13.9757619,22.6761591 L14.7517689,21.8967139 C15.1414291,21.5053273 15.7745925,21.5039278 16.165979,21.8935879 C16.2430937,21.9703624 16.3071604,22.0592086 16.3556526,22.1566226 L16.3936378,22.2329296 C16.6397543,22.7273435 17.2400728,22.9286284 17.7344867,22.6825119 C17.8319007,22.6340197 17.9207469,22.569953 17.9975214,22.4928383 L18.5728792,21.9149313 C18.9625393,21.5235448 19.5957027,21.5221452 19.9870893,21.9118053 C20.0683121,21.9926699 20.1350289,22.0868956 20.1843249,22.1903659 L20.7988342,23.4801953 L20.7988342,23.4801953",
    id: "Path-2",
    stroke: "#000000",
    strokeWidth: 1.7
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDeborde);
export default __webpack_public_path__ + "static/media/picto-deborde.7254660ee4647eefb7cd44d369af5e60.svg";
export { ForwardRef as ReactComponent };